import { Component, ViewEncapsulation, input } from '@angular/core';

@Component({
  selector: 'ds-overline',
  templateUrl: './overline.html',
  styleUrl: './overline.scss',
  encapsulation: ViewEncapsulation.None,
})
export class OverlineComponent {
  readonly text = input.required<string>();
  readonly asHeading = input<boolean>(false);
}
